export default __webpack_public_path__ + "static/media/ckeeper.22d96db0.png";